import component from "./ModalContainer";
export default component;
